import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import PageTabNavigation, { PageTabItem } from 'src/shared/components/navigations/pageTabNavigation';
import { useUnaccountedPaymentsBadge } from '../hooks/useUnaccountedPaymentsBadge';

export default function PaymentPageTabNavigation() {
  const unaccountedPayments = useUnaccountedPaymentsBadge();

  const pageTabs: PageTabItem[] = [
    {
      label: 'invoice:payment.tabs.incomingBankPayments',
      route: RoutesEnum.PaymentTransactions,
      badgeCount: unaccountedPayments,
    },
    {
      label: 'invoice:payment.tabs.paymentAccounting',
      route: RoutesEnum.PaymentAccounting,
    },
    {
      label: 'invoice:payment.tabs.paymentDistribution',
      route: RoutesEnum.PaymentDistribution,
    },
  ];

  return <PageTabNavigation pageTabs={pageTabs} />;
}
